import PropTypes from "prop-types";
import * as React from "react";
import css from "./Divider.module.css";

const Divider = React.forwardRef(
  (
    { orientation = "horizontal", decorative = false, className, ...rest },
    ref,
  ) => {
    const isHorizontal = orientation === "horizontal";
    const Element = isHorizontal ? "hr" : "div";
    const classes = [isHorizontal ? css.horizontal : css.vertical, className]
      .filter(Boolean)
      .join(" ");

    return (
      <Element
        ref={ref}
        className={classes}
        role={decorative ? "presentation" : "separator"}
        aria-orientation={decorative ? undefined : orientation}
        {...rest}
      />
    );
  },
);

Divider.displayName = "Divider";

Divider.propTypes = {
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  decorative: PropTypes.bool,
  className: PropTypes.string,
};

export default Divider;
